import Holidays, { type HolidaysTypes } from 'date-holidays';
import { isNil, isString } from 'lodash';

import { ISO3166Countries } from './country';

export function getYearHolidaysForCountry(
  country: string,
  year?: number,
  lang = 'en'
): Record<string, string>[] {
  if (isNil(country) || !isString(country)) {
    throw new Error('Core: getYearHolidaysForCountry(): Invalid country');
  }

  let resolvedYear = year;
  if (isNil(resolvedYear)) {
    resolvedYear = new Date().getFullYear();
  }

  let resolvedCountry = country;
  const upper = resolvedCountry.toUpperCase();
  if (upper.length === 3) {
    const entry = ISO3166Countries[upper as keyof typeof ISO3166Countries];
    // Unknown alpha-3 must fail validation (same as assigning undefined iso2 lookup in legacy code).
    resolvedCountry = entry ? entry.iso2 : '';
  }

  if (
    isNil(resolvedCountry) ||
    !isString(resolvedCountry) ||
    resolvedCountry.length > 3 ||
    resolvedCountry.length < 2
  ) {
    throw new Error('Core: getYearHolidaysForCountry(): Invalid country');
  }

  const holidays = new Holidays(resolvedCountry.toLowerCase());
  const holidaysList = holidays.getHolidays(resolvedYear, lang);

  return holidaysList.map((holiday: HolidaysTypes.Holiday) => ({
    date: holiday.date.substring(0, 10),
    name: holiday.name
  }));
}
